export var HandoffReason;
(function (HandoffReason) {
    HandoffReason["ESCALATION"] = "ESCALATION";
    HandoffReason["COMPLETED"] = "COMPLETED";
    HandoffReason["ERROR"] = "ERROR";
    HandoffReason["TIMEOUT"] = "TIMEOUT";
})(HandoffReason || (HandoffReason = {}));
//# sourceMappingURL=handoff.js.map